module.exports = __webpack_public_path__ + "img/mulCand.613a4a55.svg";